import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import homesImage1 from '../assets/Gallery/6.jpeg';
import homesImage2 from '../assets/Gallery/19.jpeg';
import homesImage3 from '../assets/Gallery/24.jpeg';
import homesImage4 from '../assets/Gallery/3.jpeg';
import homesImage5 from '../assets/Gallery/2.jpeg';
import homesImage6 from '../assets/Gallery/14.jpeg';
import homesImage7 from '../assets/Gallery/15.jpeg';
import homesImage8 from '../assets/Gallery/21.jpeg';
import homesImage9 from '../assets/Gallery/39.jpeg';

import volunteersImage1 from '../assets/Gallery/34.jpeg';

import holyMassImage1 from '../assets/Gallery/48.jpeg';
import holyMassImage2 from '../assets/Gallery/40.jpeg';
import holyMassImage3 from '../assets/Gallery/43.jpeg';
import holyMassImage4 from '../assets/Gallery/42.jpeg';
import holyMassImage5 from '../assets/Gallery/50.jpeg';

const Gallery = () => {
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const images = {
        Homes: [
            { src: homesImage1, alt: 'Homes 1' },
            { src: homesImage2, alt: 'Homes 2' },
            { src: homesImage3, alt: 'Homes 3' },
            { src: homesImage4, alt: 'Homes 4' },
            { src: homesImage5, alt: 'Homes 5' },
            { src: homesImage6, alt: 'Homes 6' },
            { src: homesImage7, alt: 'Homes 7' },
            { src: homesImage8, alt: 'Homes 8' },
            { src: homesImage9, alt: 'Homes 9' },
        ],
        Volunteers: [
            { src: volunteersImage1, alt: 'Volunteers 1' },

        ],
        HolyMass: [
            { src: holyMassImage1, alt: 'Holy Mass 1' },
            { src: holyMassImage2, alt: 'Holy Mass 2' },
            { src: holyMassImage3, alt: 'Holy Mass 3' },
            { src: holyMassImage4, alt: 'Holy Mass 4' },
            { src: holyMassImage5, alt: 'Holy Mass 5' },
        ],
    };

    const allImages = [
        ...images.Homes,
        ...images.Volunteers,
        ...images.HolyMass,
    ];

    const getImagesToDisplay = () => {
        if (selectedCategory === 'All') {
            return allImages;
        }
        return images[selectedCategory] || [];
    };

    // Determine button size based on screen width
    const getButtonSize = () => {
        if (windowWidth < 576) return 'sm';
        return '';
    };

    // Determine columns based on screen width
    const getColumns = () => {
        if (windowWidth < 576) return 12; // 1 column on mobile portrait
        if (windowWidth < 768) return 6;  // 2 columns on mobile landscape/small tablet
        return 4;                         // 3 columns on tablet and desktop
    };

    return (
        <div className="container px-3 px-md-4 py-4 py-md-5">
            <h2 className="text-center mb-4 mb-md-5 fw-bold" style={{
                fontFamily: 'Georgia',
                fontSize: windowWidth < 768 ? '1.75rem' : '2.25rem'
            }}>
                Our Gallery
            </h2>

            <div className="d-flex flex-wrap justify-content-center mb-4 mb-md-5 gap-2">
                <button
                    className={`btn ${getButtonSize()} ${selectedCategory === 'All' ? 'btn-primary' : 'btn-outline-primary'} mx-1 mx-md-2`}
                    onClick={() => setSelectedCategory('All')}
                >
                    All
                </button>
                <button
                    className={`btn ${getButtonSize()} ${selectedCategory === 'Homes' ? 'btn-primary' : 'btn-outline-primary'} mx-1 mx-md-2`}
                    onClick={() => setSelectedCategory('Homes')}
                >
                    Homes
                </button>
                <button
                    className={`btn ${getButtonSize()} ${selectedCategory === 'Volunteers' ? 'btn-primary' : 'btn-outline-primary'} mx-1 mx-md-2`}
                    onClick={() => setSelectedCategory('Volunteers')}
                >
                    Volunteers
                </button>
                <button
                    className={`btn ${getButtonSize()} ${selectedCategory === 'HolyMass' ? 'btn-primary' : 'btn-outline-primary'} mx-1 mx-md-2`}
                    onClick={() => setSelectedCategory('HolyMass')}
                >
                    Holy Mass
                </button>
            </div>

            <div className="row g-3 g-md-4">
                {getImagesToDisplay().map((image, index) => (
                    <div key={index} className={`col-${getColumns()}`}>
                        <div className="ratio ratio-1x1">
                            <img
                                src={image.src}
                                alt={image.alt}
                                className="img-fluid rounded shadow"
                                style={{
                                    objectFit: 'cover',
                                    transition: 'transform 0.3s ease',
                                }}
                                onMouseOver={(e) => windowWidth >= 768 && (e.currentTarget.style.transform = 'scale(1.02)')}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                loading="lazy"
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Gallery;